module.exports = __webpack_public_path__ + "img/1920_footer_icon3.1e31643c.svg";